import React from 'react';
import PropTypes from 'prop-types';
import {DESTINATION_DATA} from 'destination/destination-prop-types';
import moment from 'moment';
import withConfig from 'config/withConfig';
import IconInfo from '@spothero/icons/info';
import TextButton from '@spothero/ui/text-button';
import EventSchema from 'event/EventSchema';
import SearchBreadcrumbsDesktop from '../breadcrumbs/SearchBreadcrumbsDesktop';
import SpotListAvailabilityDesktop from '../spot-list/SpotListAvailabilityDesktop';

const EventFeatureDesktop = ({
    breadcrumbs,
    city,
    destination,
    event: {
        title,
        starts,
        ends,
        search_url: eventUrl,
        description,
        short_description: shortDescription,
        meta_description: eventMetaDescription,
    },
    isFetchComplete,
    numSpots,
    onShowInfoModal,
    displayEventDateFormat,
}) => {
    const {timezone} = city;
    const startsInTimezone = moment.tz(starts, timezone);
    const endsInTimezone = moment.tz(ends, timezone);
    const eventDateDisplay = startsInTimezone.format(displayEventDateFormat);
    const startsISO = startsInTimezone.toISOString();
    const endsISO = endsInTimezone.toISOString();
    const {description: destinationDescription} = destination;

    return (
        <div className="EventFeature">
            <div className="detail">
                <SearchBreadcrumbsDesktop data={breadcrumbs} />
                <h1 className="feature-heading">
                    <span>{unescape(title)} Parking</span>
                    <meta itemProp="name" content={title} />
                    {(description || destinationDescription) && (
                        <TextButton
                            className="feature-info-link"
                            onClick={onShowInfoModal}
                        >
                            <IconInfo />
                        </TextButton>
                    )}
                </h1>
                <EventSchema
                    url={eventUrl}
                    metaName={title}
                    metaDescription={eventMetaDescription}
                    starts={startsISO}
                    ends={endsISO}
                    destination={destination}
                    city={city}
                />
                <p className="date">
                    <small>{eventDateDisplay}</small>
                </p>
                {shortDescription && (
                    <p className="CityFeature-short-description">
                        <span
                            dangerouslySetInnerHTML={{__html: shortDescription}}
                        />
                        <TextButton onClick={onShowInfoModal}>
                            <small>[Read More...]</small>
                        </TextButton>
                    </p>
                )}
                <SpotListAvailabilityDesktop
                    isFetchComplete={isFetchComplete}
                    numSpots={numSpots}
                />
            </div>
        </div>
    );
};

EventFeatureDesktop.propTypes = {
    breadcrumbs: PropTypes.object.isRequired,
    destination: PropTypes.shape(DESTINATION_DATA).isRequired,
    event: PropTypes.object.isRequired,
    city: PropTypes.object.isRequired,
    isFetchComplete: PropTypes.bool.isRequired,
    numSpots: PropTypes.number.isRequired,
    onShowInfoModal: PropTypes.func.isRequired,
    displayEventDateFormat: PropTypes.string.isRequired,
};

export default withConfig(['displayEventDateFormat'])(EventFeatureDesktop);
